import { memo } from "react";

import Typography from "@mui/material/Typography";

import { getMarkdownAsReact } from "utility/markdown";

import Abstract from "./Abstract";

// -----------------------------------------------------------------------------

const OrganizationFindingUndoFixRow = memo(
  function OrganizationFindingUndoFixRow({
    undo,
  }: OrganizationFindingUndoFixRowProps): JSX.Element {
    return (
      <Abstract label="Undo">
        <Typography variant="body1" component="div">
          {undo ? getMarkdownAsReact(undo.trim()) : "Cannot be undone."}
        </Typography>
      </Abstract>
    );
  }
);

export default OrganizationFindingUndoFixRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingUndoFixRowProps {
  undo: string | null;
}
